export const performInterruptionSafeAnimation = (
  map,
  animate,
  animationDuration = 0,
) => {
  let firstRunTimestamp;
  const handleInterruption = () => {
    const animationDurationLeft = firstRunTimestamp
      ? animationDuration - (Date.now() - firstRunTimestamp)
      : animationDuration;

    animate(animationDurationLeft);
  };

  map.on('resize', handleInterruption);
  const timeout = setTimeout(() => {
    map.off('resize', handleInterruption);
  }, animationDuration);

  handleInterruption();

  return () => {
    if (timeout) {
      clearTimeout(timeout);
    }

    map.off('resize', handleInterruption);
  };
};
